// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorShift_container__zeMdx","top":"ColorShift_top__KYSMu","bottom":"ColorShift_bottom__WsyAF"};